<template>
  <div class="loading-wrapper">
    <div v-if="conteudo" class="loading-conteudo-container">
      <transition name="fadeConteudo">
        <div
          v-for="(item, index) in conteudo"
          :key="index"
          v-if="index == fraseIndex"
          :class="['loading-conteudo', { 'conteudo-background': background }]"
        >
          {{ item }}
        </div>
      </transition>
    </div>
    <Quadrado v-if="tipo == 'quadrado'" :tamanho="tamanho" :classe="classe" />
    <Circulo v-if="tipo == 'circulo'" :escala="escala" :classe="classe" />
    <Bloco v-if="tipo == 'bloco'" :tamanho="tamanho" :classe="classe" />
    <Linha v-if="tipo == 'linha'" :tamanho="tamanho" :numero="numero" :classe="classe" />
    <Simples v-if="tipo == 'simples'" :tamanho="tamanho" :classe="classe" />
  </div>
</template>

<script>
import Bloco from "./Bloco.vue";
import Circulo from "./Circulo.vue";
import Linha from "./Linha.vue";
import Quadrado from "./Quadrado.vue";
import Simples from "./Simples.vue";

export default {
  name: "LoadingPadrao",
  components: { Circulo, Quadrado, Bloco, Linha, Simples },
  props: {
    background: Boolean,
    tipo: String,
    conteudo: Array,
    escala: String,
    tamanho: String,
    classe: String,
    numero: String,
    delay: String
  },
  mounted() {
    this.trocaConteudo();
  },
  data() {
    return {
      fraseIndex: 0
    };
  },
  methods: {
    trocaConteudo() {
      if (this.conteudo && !!this.conteudo.length) {
        if (this.fraseIndex >= this.conteudo.length - 1) {
          setTimeout(
            () => {
              this.fraseIndex = 0;
              this.trocaConteudo();
            },
            this.delay ? this.delay : 2000
          );
        } else {
          setTimeout(
            () => {
              this.fraseIndex += 1;
              this.trocaConteudo();
            },
            this.delay ? this.delay : 2000
          );
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
}
.loading-conteudo {
  position: absolute;
  white-space: nowrap;
  font-family: "Roboto Condensed";
  font-size: 15px;
}
.conteudo-background {
  background: linear-gradient(to right, transparent, #00000086 10%, #00000086 90%, transparent);
  padding: 0 10px;
}
.fadeConteudo-enter-active {
  transition: all 0.5s 0.3s ease-in-out;
}
.fadeConteudo-leave-active {
  transition: all 0.5s ease-in-out;
}
.fadeConteudo-enter,
.fadeConteudo-leave-to {
  opacity: 0;
}
.loading-conteudo-container {
  position: relative;
  display: flex;
  justify-content: center;
  height: 30px;
}
</style>
